import * as actionType from "../../../constants";
import * as commonData from "../../../Common";

export const getAllCategory = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}system/category/list`, {
      method: "post",
      body: JSON.stringify({
        app_token: inputs.app_token,
        attribute_set_key: inputs.attribute_set_key,
      }),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.STATUS_GET_ALL_CATEGORY,
        payload: {
          cate: rdata.data.all_records,
          workflow_cate: rdata.data.workflow_categories,
          board: inputs.board,
        },
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const createWorkflow = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  dispatch({ type: actionType.WORKFLOW_CLOSE_MODAL });
  try {
    const response = await fetch(`${url}workflow/add`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      dispatch({
        type: actionType.CREATE_WORKFLOW_STATUS,
        payload: {
          createSingle: rdata.data,
          message: rdata.message,
          title: rdata.status,
          board: true,
          code: rdata.code,
        },
      });
      dispatch(
        getAllCategory({
          app_token: inputs.app_token,
          attribute_set_key: inputs.attribute_set_key,
          board: true,
        })
      );
    } else {
      dispatch({
        type: actionType.CREATE_SINGLE_WORKFLOW_ERROR,
        payload: {
          message: rdata.message,
          title: rdata.status,
          board: true,
          code: rdata.code,
        },
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const createSingleCategory = (inputs) => async (dispatch) => {
  console.log("create category", inputs);
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}system/category/create`, {
      method: "post",
      body: JSON.stringify(inputs),
    });

    const rdata = await response.json();
    if (rdata.code === 200) {
      console.log("res data", rdata);
      dispatch({
        type: actionType.STATUS_CREATE_NEW_CATEGORY,
        payload: {
          category: rdata.data.category,
          message: rdata.message,
          title: rdata.status,
          board: true,
        },
      });
    } else {
      console.log("res data", rdata);
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const getAllWorkflow = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}workflow/list`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      console.log("res", rdata);
      dispatch({ type: actionType.GET_ALL_WORKFLOW_LIST, payload: rdata.data });
    } else {
      dispatch({ type: actionType.NULL_WORKFLOW_LIST });
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const updateWorkfloeSingle = (inputs) => async (dispatch) => {
  const url = commonData.commonData().apiUrl;
  dispatch({ type: actionType.WORKFLOW_CLOSE_MODAL });
  try {
    const response = await fetch(`${url}workflow/update`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      console.log("res", rdata);
      dispatch({
        type: actionType.UPDATE_WORKFLOW_SINGLE,
        payload: {
          singleWork: rdata.data,
          workid: inputs.workflow_id,
          board: true,
          message: rdata.message,
          title: rdata.status,
          code: rdata.code,
        },
      });

      setTimeout(() => {
        dispatch({ type: actionType.DEACTIVATE_STATUSWORKFLOW_MESSAGE });
      }, 4000);
    } else {
      dispatch({
        type: actionType.CREATE_SINGLE_WORKFLOW_ERROR,
        payload: {
          message: rdata.message,
          title: rdata.status,
          board: true,
          code: rdata.code,
        },
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};

export const deactivateStatusWorkflow = () => async (dispatch) => {
  dispatch({ type: actionType.DEACTIVATE_STATUSWORKFLOW_MESSAGE });
};

export const removeWorkFlowCategory = (inputs) => async (dispatch) => {
  console.log("input", inputs);
  const url = commonData.commonData().apiUrl;
  try {
    const response = await fetch(`${url}workflow/delete-category`, {
      method: "post",
      body: JSON.stringify(inputs),
    });
    const rdata = await response.json();
    if (rdata.code === 200) {
      console.log("rdata", rdata);
      dispatch({
        type: actionType.DELETE_SINGLE_CATEGORY_WORKFLOW,
        payload: {
          deleCategory: rdata.data[0],
          workflow_id: inputs.workflow_id,
          message: rdata.message,
          title: rdata.status,
          board: true,
        },
      });
    }
  } catch (error) {
    console.log(error.message);
  }
};
